import React from 'react';
import { ar, enUS } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import InfoText from './InfoText';
import { formatInTimeZone } from 'date-fns-tz';

interface LocalDateProps {
  date: string | Date;
  formatStr: string;
  className?: string;
  testId?: string;
}

export default function LocalDate({
  date,
  formatStr,
  className,
  testId,
}: LocalDateProps) {
  const {
    i18n: { language },
  } = useTranslation();
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  let formatted = '-';
  if (date) {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      try {
        formatted = formatInTimeZone(parsedDate, userTimezone, formatStr, {
          locale: language?.startsWith('ar') ? ar : enUS,
        });
      } catch (error) {
        console.error('Error formatting date:', error);
      }
    }
  }

  return (
    <InfoText text={formatted} className={className} data-testid={testId} />
  );
}
